/**
 * 同步中心翻译 - 中文
 * Sync Center - Chinese
 */
export const syncCenterZh = {
  sidebar: {
    title: '同步中心',
    entraId: 'Entra ID 同步',
    dingtalk: '钉钉同步',
    dingtalkEmployees: '员工管理',
    dingtalkQuotas: '假期余额总览',
    dingtalkRelease: '年假释放计划',
    dingtalkSap: 'SAP采购同步',
    adp: 'ADP PTO 同步',
    adpPto: 'PTO 时段查看',
  },
  adp: {
    taskName: {
      ADP_LINKER: 'ADP 员工 ID 绑定',
      ADP_PTO_SYNC: 'ADP PTO 时段同步',
    },
    pageTitle: 'ADP PTO 同步',
    pageDescription:
      '管理员数据校验工具。仅显示员工与 PTO 时段，不含请假类型/原因（合规：CPRA）。',
    loading: '加载中...',
    statusBadge: {
      success: '成功',
      failed: '失败',
      running: '运行中',
      timeout: '超时',
    },
    task: {
      lastRun: '上次执行',
      totals: '累计 / 成功 / 失败',
      lastDuration: '上次耗时',
      runNow: '立即触发',
      running: '正在执行...',
      lastError: '上次错误',
      lastLogs: '上次日志',
    },
    configMissing: 'ADP 配置缺失：',
    filter: {
      startDate: '起始日期',
      endDate: '截止日期',
      search: '搜索（姓名 / 邮箱）',
      searchPlaceholder: '按姓名或邮箱模糊搜索',
      refresh: '刷新',
    },
    summary: '共 {total} 条；当前第 {page} / {totalPages} 页',
    table: {
      employee: '员工',
      email: '邮箱',
      date: '日期 (员工本地)',
      timeRange: '起止时间 (员工本地)',
      syncedAt: '同步时间',
      empty: '无数据',
    },
    pagination: {
      prev: '上一页',
      next: '下一页',
    },
    unmatched: {
      title: '未匹配的 ADP 员工',
      desc: '邮箱差异或不同步导致没自动绑定。可手动搜 FF AI 用户绑定。',
      empty: '没有未匹配的 ADP 员工',
      lastRunAt: '基于上次 Linker 执行（{time}）',
      colAdp: 'ADP 员工',
      colMatch: '手动匹配 FF AI 用户',
      searchPlaceholder: '输入姓名 / 邮箱搜索（≥ 2 字符）',
      bind: '绑定',
      binding: '绑定中...',
      bindSuccess: '已绑定 {email} → {aoid}',
      bindFail: '绑定失败：{msg}',
      pickFirst: '请先选一个 FF AI 用户',
      noResult: '未找到匹配的 FF AI 用户',
    },
    toast: {
      statusFailed: '加载同步状态失败：{msg}',
      listFailed: '加载 PTO 列表失败：{msg}',
      dateRangeError: '时间范围超过允许窗口（最大 -30 天 ~ +60 天）',
      triggerAccepted: '已开始执行，请稍候自动刷新…',
      triggerAlreadyRunning: '该任务正在执行中，请等待完成后再试',
      triggerLinkerFail: '触发 Linker 失败：{msg}',
      triggerPtoFail: '触发 PTO 同步失败：{msg}',
      runFinishedSuccess: '{taskName} 执行完成 ✅',
      runFinishedFailed: '{taskName} 执行失败 ❌',
    },
  },
};
